import { useEffect, useState } from "react"

import Avatar from "@mui/material/Avatar"
import AvatarGroup from "@mui/material/AvatarGroup"

import { defaultCoverFor } from "@utils/localCoverImage"
import { getTeeupStatusOption } from "@utils/teeupUtils"

import "./index.scss"
import cn from "classnames"

interface Props {
  teeup: any
  teeupPeople?: any[]
  onClick?: (id: number) => void
  isFromOutside?: boolean
}

interface Status {
  label: string
  backgroundColor: string
  value: string
}

const TeeupItem = ({ teeup, teeupPeople, onClick, isFromOutside }: Props) => {
  const [status, setStatus] = useState<Status | null>(null)
  const { gameplans } = teeup
  const [when, where] = gameplans
  const suggestionsCount =
    when?.suggestions?.length + where?.suggestions?.length || 0
  const participantsCount =
    teeup?.participants?.length || teeupPeople?.length || 0
  const participants = teeup?.participants || teeupPeople || []

  // BUG-FIX 2026-07-04: rows rendered a raw <img src={teeup.photo}> with no fallback, so a
  // null/undefined photo (or a dead URL) showed as a blank white box. Reuse the same
  // deterministic bundled-default cover helper the inbox card / detail header already use
  // (@utils/localCoverImage, shared with TeeUpPhoto.tsx) so a TeeUp here is never coverless.
  const coverFallback = defaultCoverFor(teeup?.id ?? teeup?.name)
  const [coverSrc, setCoverSrc] = useState<string>(teeup?.photo || coverFallback)

  useEffect(() => {
    setCoverSrc(teeup?.photo || coverFallback)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teeup?.photo, coverFallback])

  useEffect(() => {
    const status = getTeeupStatusOption(teeup.status)
    if (!status) return

    setStatus(status)
  }, [teeup])

  return (
    <div
      className="my-profile-suggestion"
      onClick={() => onClick && onClick(teeup.id)}>
      <div className="my-profile-suggestion-info-container">
        <div>
          <img
            src={coverSrc}
            alt=""
            onError={() => {
              if (coverSrc !== coverFallback) setCoverSrc(coverFallback)
            }}
          />
        </div>

        <div className="my-profile-suggestion-info">
          <h2>{teeup.name}</h2>
          <p>{suggestionsCount} Suggestions</p>
          <p>{participantsCount} Participants</p>
          <div
            className={cn({
              "my-profile-suggestion-from-outside": isFromOutside,
            })}>
            <AvatarGroup max={5} className="my-profile-avatar-group">
              {participants?.map((participant: any) => (
                <Avatar
                  alt="user-avatar"
                  src={participant.avatar}
                  sx={{ width: 24, height: 24 }}
                />
              ))}
            </AvatarGroup>
          </div>
        </div>
      </div>

      {status && (
        <div
          className="my-profile-suggestion-status"
          style={{
            backgroundColor: status?.backgroundColor || "",
            color: status?.value || "",
          }}>
          {status.label}
        </div>
      )}
    </div>
  )
}

export default TeeupItem
